import { Asset } from "../../state/types";

export const buildAssetLookupCandidates = (assetInstanceId: string): string[] => {
  const trimmed = assetInstanceId.trim();
  if (!trimmed) return [];

  const baseId = trimmed.split("-")[0];
  return baseId && baseId !== trimmed ? [trimmed, baseId] : [trimmed];
};

export const findMatchingAsset = (assets: Asset[], assetInstanceId: string): Asset | undefined => {
  return assets.find((candidate) => candidate.assetInstanceId === assetInstanceId || candidate.assetId === assetInstanceId);
};
